import { RefreshCw, ExternalLink } from "lucide-react";
import { viaggiareSicuriUrl } from "../../data/countries";
import { DASH, localeFor, formatDate } from "./format";

export default function CountryInfo({ code, name, currency, rate, language, t }) {
  return (
    <div className="p-6 space-y-5" data-testid="trasferte-info-panel">
      <div className="flex items-center gap-4">
        <img
          src={`https://flagcdn.com/${code.toLowerCase()}.svg`}
          alt={name}
          className="w-20 h-14 object-cover rounded-md border border-slate-200 shadow-sm shrink-0"
        />
        <div className="min-w-0">
          <h2 className="text-2xl font-bold text-slate-900 break-words">{name}</h2>
          <p className="text-sm text-slate-400">{code}</p>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div className="border border-slate-100 rounded-lg p-4 bg-slate-50/50 min-w-0">
          <h3 className="text-xs uppercase tracking-wide text-slate-500 mb-2">
            {t("trasferte.localCurrency")}
          </h3>
          {currency ? (
            <p className="text-slate-800 font-medium capitalize break-words">
              {currency.currency_name}{" "}
              <span className="text-slate-400 normal-case">{DASH} {currency.currency_code}</span>
            </p>
          ) : (
            <p className="text-slate-400 text-sm">{t("trasferte.currencyUnknown")}</p>
          )}
        </div>

        <div className="border border-slate-100 rounded-lg p-4 bg-slate-50/50 min-w-0">
          <h3 className="text-xs uppercase tracking-wide text-slate-500 mb-2 flex items-center gap-1.5">
            <RefreshCw className="w-3 h-3 shrink-0" />
            {t("trasferte.exchangeRate")}
          </h3>
          {!currency ? (
            <p className="text-slate-400 text-sm">{DASH}</p>
          ) : !rate ? (
            <p className="text-slate-400 text-sm">{t("trasferte.loading")}</p>
          ) : rate.error ? (
            <p className="text-amber-600 text-sm">{t("trasferte.rateError")}</p>
          ) : (
            <>
              <p className="text-slate-800 font-medium break-words">
                1 EUR = {Number(rate.rate).toLocaleString(localeFor(language), { maximumFractionDigits: 4 })} {currency.currency_code}
              </p>
              <p className="text-xs text-slate-400 mt-1">
                {t("trasferte.lastUpdated")}: {formatDate(rate.fetchedAt, language)}
              </p>
            </>
          )}
        </div>
      </div>

      <div>
        <a
          href={viaggiareSicuriUrl(code)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="trasferte-viaggiaresicuri-link"
          className="inline-flex items-center gap-2 px-4 py-2.5 bg-indigo-700 hover:bg-indigo-600 text-white rounded-lg text-sm font-medium transition-colors"
        >
          {t("trasferte.viaggiareSicuri")}
          <ExternalLink className="w-4 h-4 shrink-0" />
        </a>
      </div>
    </div>
  );
}
